import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../News/AiNews.css";
import aws_success from "../../assets/images/aws_success.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const AiNewsPage = () => {
    return (
        <div>
            <Helmet>
                <title>Idexcel Achieves AWS Generative AI Services Competency</title>
                <meta
                    content="Idexcel Achieves AWS Generative AI Services Competency"
                    name="keywords"
                />
                <meta
                    content="Read our latest Ai Competence News to learn how Idexcel helped clients transform their businesses and stay at the top of our ever-changing industry."
                    name="description"
                />
            </Helmet>
            <motion.div
                className="Productright"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <Container fluid className="ai-banner-container p-0">
                    <section className="ai-banner-section"></section>
                </Container>
            </motion.div>

            <section className="ai-stories-section ">
                <Container className="my-5 px-xl-5" style={{ textAlign: "justify" }}>
                    {/* <h2 className="text-center mb-4 section-title">
                        <span className="textgrad"> Success</span> Stories
                    </h2> */}
                    {/* <h4
                        className="text-black mb-5 text-left"
                        style={{ lineHeight: "unset" }}
                    >
                        <span className="fw-semibold"> AWS Partner Story:</span> Idexcel
                        Manages and Maintains Cync Software's flagship product "Cync
                        Application Suite" on Amazon Web Services Infrastructure
                    </h4> */}
                    <section>
                        {/* <h4 className="fw-semibold">About Cync Software</h4> */}
                        <p className="pt-2 m-0  mb-2">
                            {/* <a
                                style={{ padding: "inherit" }}
                                className="text-danger textDecoration"
                                target="_blank"
                                href="https://www.ndsapps.com/"
                            >
                                NDS Systems
                            </a> */}
                            {/* <b>Herndon, Virginia, January 20, 2026:</b> */}
                            Idexcel, an AI-first technology and services company, today announced that it has achieved the Amazon Web Services (AWS) Generative AI Services Competency. This achievement reflects Idexcel’s AI-first approach and its ability to deliver real-world, production-grade AI solutions. These solutions help organizations modernize operations, improve decision-making, and drive measurable business outcomes.
                        </p>
                    </section>
                    <section className="mt-3">
                        {/* <h4 className="fw-semibold">
                            Innovating in the Commercial Lending Market
                        </h4> */}
                        <p className="pt-2 m-0 ">
                            The AWS Generative AI Services Competency is awarded to partners that meet AWS’s rigorous criteria for technical depth, architectural excellence, and successful customer implementations. This recognition highlights Idexcel’s experience in applying Generative AI to address real customer challenges.
                        </p>
                        <p className="pt-2 my-2">
                            Idexcel supports organizations across multiple AI-driven initiatives, including:
                        </p>

                        <ul
                            className="custom-orange-list fs-5"
                            style={{
                                listStyleType: "disc",
                                paddingLeft: "2.8rem",
                            }}
                        >
                            <li className="mb-2">Intelligent automation across business and IT workflows</li>
                            <li className="mb-2">AI-led customer experience transformation</li>
                            <li className="mb-2">Advanced data-driven insights and decision intelligence</li>
                            <li>Emerging AI use cases aligned with business priorities</li>
                        </ul>
                        <Container fluid className="bg-grey px-0">
                            <Container className="orange-side-borders">
                                <Row className="p-0 m-0 bg-grey content  pt-xl-3 pb-2">
                                    <Container className="px-0  ">
                                        <section className="ck-custom-singleblog-post px-0 px-lg-3 pt-1 pb-3">
                                            <blockquote className="ck-custom-singleblog-post-content">
                                                <p>
                                                    “This recognition reinforces our strength in helping customers - particularly in Financial Services - deploy Gen AI in ways that accelerate decisions, reduce operational complexity, and deliver seamless customer experiences at scale. It’s a testament to our team's ability to translate innovation into measurable business impact.”
                                                </p>
                                                <p className="d-flex align-items-center gap-3 mt-3 mb-0">
                                                    <strong className="author-name">
                                                        Allolankandy Anand, Vice President - Digital Transformation & Strategy at Idexcel.
                                                    </strong>
                                                </p>
                                            </blockquote>
                                        </section>
                                    </Container>
                                </Row>
                            </Container>
                        </Container>
                        <p className=" m-0  my-2 mb-2">
                            For our customers, this means our AI services designed with strong governance in mind, including regulatory alignment, security controls, and human-in-the-loop oversight. Our focus is on helping enterprises adopt AI in a controlled and accountable manner, with compliance, transparency, and risk management embedded from the start.
                        </p>
                    </section>
                    <section className="mt-4">
                        <h4 className="fw-semibold fs-3">A Continued Commitment to AI Innovation </h4>
                        <p className=" m-0 ">
                            Earning the AWS Generative AI Services Competency underscores Idexcel’s continued investment in advanced AI capabilities and its commitment to helping enterprises stay ahead as AI adoption accelerates across industries.
                        </p>
                        <p className="pt-2 m-0  my-2">
                            With AWS as a strategic partner, Idexcel enables organizations to confidently embed AI into their core operations and long-term digital strategies.
                        </p>

                        <p className="pt-2 m-0  my-2">
                            Want to learn more about how Idexcel can help you?
                        </p>
                    </section>
                    <div className="text-center mt-4">
                        <div className="text-center mt-4">
                            <button
                                onClick={() => (window.location.href = "/contact-us")}
                                style={{
                                    backgroundColor: "#f06319",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "16px 24px 10px 24px",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    fontWeight: "700",
                                }}
                            >
                                TALK TO OUR AI EXPERTS
                            </button>
                        </div>
                    </div>
                </Container>
            </section>
            {/* <Container fluid className="bg-grey orange-side-borders">
                <Row className="p-0 m-0 bg-grey content px-xl-5 pt-xl-5 pb-5">
                    <Container className="px-3 px-xl-2 px-lg-0">
                        <section className="ck-custom-singleblog-post px-0 px-lg-5 pt-1 pb-3">
                            <blockquote className="ck-custom-singleblog-post-content">
                                <p>
                                    “Achieving the AWS AI Services Competency underscores our responsibility to help customers apply AI with clarity and purpose.”
                                </p>

                                <p className="d-flex align-items-center gap-3 mt-3 mb-0">

                                    <strong>
                                        Allolankandy Anand, Vice President -Digital Transformation & Strategy at Idexcel.
                                    </strong>
                                </p>
                            </blockquote>
                        </section>
                    </Container>
                </Row>
            </Container> */}

        </div>
    );
};

export default AiNewsPage;
